module.exports = __webpack_public_path__ + "static/media/a.acc56c40.png";